import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { HotelsPageComponent } from './hotels-page.component';
import { SharedModule } from '@modules/tours/shared/shared.module';

@NgModule({
  declarations: [HotelsPageComponent],
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule
  ],
  exports: [HotelsPageComponent]
})
export class HotelsPageModule { }
